"use client"
import React, {FC} from 'react';
import {WidgetProps, WidgetTitleBar} from './component/widgetTitleBar';
import {useDispatch} from 'react-redux';

import Image from 'next/image';
import {useTranslations} from "use-intl";
import {BANNER_LARGE_SIZE, BANNER_MEDIUM_SIZE, BANNER_SMALL_SIZE, HTTP_KEY, MAIN_APP_URL} from "@/core/CONSTANTS";
import {AppDispatch} from "@/core/redux/store";
import useLocalStorage from "@/core/utils/localStorage";
import {LOGIN_STATE_KEY} from "@/core/services/CONSTANTS";
import {MenuBuilderShortcutModel} from "@/core/model/main.model";
import {WidgetContainerComponent} from "@/core/general/ui/widgetContainer.component";
import {Column} from "@/core/general/column.component";
import {loginState} from "@/core/reducer/loginReducer";
import {LOGIN_STATE} from "@/core/reducer/CONSTANTS";
import {useRouter} from "next/navigation";
import {Swiper, SwiperSlide} from 'swiper/react';
import {BRT_MAP, MENU_BUILDER, SUBWAY_MAP} from "@/core/navigation/CONSTANTS";
import {shortcutState} from "@/core/reducer/shortcutReducer";
import queryString from "query-string";

const BannerSliderWidgetComponent: FC<WidgetProps> = (props) => {
  const router = useRouter();
  const t = useTranslations();

  function getHeight() {
    switch (props.widget.schema_data.size) {
      case BANNER_LARGE_SIZE:
        return 'aspect-[32/17]';
      case BANNER_MEDIUM_SIZE:
        return 'aspect-[32/10]';
      case BANNER_SMALL_SIZE:
        return 'aspect-[32/5]';
      default:
        return 'aspect-[32/10]';
    }
  }

  const dispatch = useDispatch<AppDispatch>();
  const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);

  function getShortcutTitle(shortcut: MenuBuilderShortcutModel) {
    if (shortcut.title) {
      return shortcut.title.fa;
    } else {
      return t(`shName.${shortcut.unique_name}`);
    }
  }

  function handleShortcutClick(shortcut: MenuBuilderShortcutModel) {
    if (shortcut?.is_enabled ?? true) {
      if ((shortcut.login_required ?? false) && !isLogin) {
        dispatch(loginState({
          openLoginPage: true,
          state: LOGIN_STATE
        }));
      } else {
        if (shortcut.url) {
          const title = getShortcutTitle(shortcut);
          clickShortcutItem(shortcut);
        }
      }
    }
  }

  function saveShortcutClickState(dispatch: AppDispatch, shortcut: MenuBuilderShortcutModel) {
    let hasSetting = false;
    switch (shortcut.unique_name) {
      case BRT_MAP.replace('/t/', ''):
      case SUBWAY_MAP.replace('/t/', ''):
        hasSetting = true;
        break;
    }
    // shortcut.isDelete = shortcut?.isDelete ?? false;
    dispatch(shortcutState({item: shortcut, hasSetting: hasSetting}));
  }
  function removeShortcutClickState(dispatch: AppDispatch) {
    dispatch(shortcutState({item:null,hasSetting:false}));
  }
  function clickShortcutItem(shortcut:MenuBuilderShortcutModel) {
    if (shortcut?.is_enabled ?? true) {
      if ((shortcut.login_required ?? false) && !isLogin) {
        dispatch(loginState({state: LOGIN_STATE, openLoginPage:true}));
      } else {
        const title = shortcut.title?.fa??t(`shName.${shortcut.unique_name}`);
        if (shortcut.url?.includes('tlbx://dynamicPage')) {
          removeShortcutClickState(dispatch);
          const qp = queryString.parseUrl(shortcut.url).query;
          if (qp && qp.group) {
            const group = qp.group.toString();
            const title = qp.title?.toString() ?? '';
            router.push(MENU_BUILDER.replace(':page', group)+`?shTitle=${title}`);
          }
        } else if (shortcut.url?.includes('tlbx://generalWebView')) {
          saveShortcutClickState(dispatch, shortcut);
          const qp = queryString.parseUrl(shortcut.url).query;
          if (qp && qp.url) {
            const path = qp.url.toString();
            if ((path.includes('tlbx.ir') || path.includes('tlbxapp.com'))&&(!path.includes('game.tlbx.ir')) && shortcut.unique_name) {
              const path: string = `/t/${shortcut.unique_name}`;
              router.push(path+`?shTitle=${title}`);
            } else {
              router.push('/t/generalWeb'+`?shTitle=${title}&title=${title}&url=${path}`);
            }
          }
        } else if (shortcut.url?.includes(HTTP_KEY)) {
          const qp = queryString.parseUrl(shortcut.url).query;
          if (qp && qp.url) {
            if (qp.url.toString().includes(MAIN_APP_URL)) {
              saveShortcutClickState(dispatch, shortcut);
              const path = qp.url.toString().split(MAIN_APP_URL)[1];
              router.push(path+`?shTitle=${title}`);
            } else {
              if (typeof window !== 'undefined') window.open(qp.url.toString(), '_self');
            }
          } else {
            if (typeof window !== 'undefined') window.open(shortcut.url.toString(), '_self');
          }
        } else {
          saveShortcutClickState(dispatch, shortcut);
          const path: string = `/t/${shortcut.unique_name}`;
          if (shortcut.url?.includes('tlbx://media')) {
            // if (path.includes('video_gardi')) {
            //     path = VIDEO_GARDI_PATH;
            // } else if (path.includes('movie')) {
            //     path = FILM_SERIAL_PATH;
            // }
            router.push(path+`${shortcut.url?.split('tlbx://media')[1]}&shTitle=${title}`);
          } else {
            router.push(path+`?shTitle=${title}`);
          }
        }
      }
    }
  }

  return (
    <WidgetContainerComponent className="fullWidth flex flex-col">
      <WidgetTitleBar widget={props.widget} hasTitle={props.hasTitle} />
      <div className="w-full">
        <Swiper
          effect="slide"
          slidesPerView={'auto'}
          spaceBetween={10}
          centeredSlides={true}
          loop={props.widget.shortcuts.length > 1}
          autoplay={{
            delay: props.widget.shortcuts.length > 1 ? 3500 : 100000,
            disableOnInteraction: false
          }}
          pagination={true}
        >
          {props.widget.shortcuts?.map((item, index) => (
            <SwiperSlide key={index} tabIndex={index} virtualIndex={index}>
              <Column className={'p-1 totalCenter mt-2'}>
                <div className="flex w-full md:w-2/3 lg:w-1/2 totalCenter px-3">
                  <Image
                    fill={true}
                    sizes={'100%'}
                    alt=""
                    className={`rounded-md ratio !relative ${getHeight()}`}
                    src={item.cover_url?.toString() ?? ''}
                    style={{ opacity: !(item.is_enabled && !item.is_enabled) ? '1' : '0.5' }}
                    onClick={() => handleShortcutClick(item)}
                  />
                </div>
              </Column>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </WidgetContainerComponent>
  );
};

export default React.memo(BannerSliderWidgetComponent);
